/**
 * @generated SignedSource<<a7a51ec13378cf26c87c2d0d7f7d0bad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type optionsSection_company$data = {
  readonly jiraCloudEnabled: boolean | null;
  readonly jiraServerEnabled: boolean | null;
  readonly integrations: {
    readonly jiraCloud: {
      readonly syncSettings: {
        readonly isJiraToForecastOneWaySync: boolean | null;
      } | null;
    } | null;
    readonly jiraServer: {
      readonly syncSettings: {
        readonly isJiraToForecastOneWaySync: boolean | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "optionsSection_company";
};
export type optionsSection_company$key = {
  readonly " $data"?: optionsSection_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"optionsSection_company">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "optionsSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraCloudEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraServerEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyIntegrationsType",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyJiraSettingsType",
          "kind": "LinkedField",
          "name": "jiraCloud",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyJiraSettingsType",
          "kind": "LinkedField",
          "name": "jiraServer",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "d24f014e71174732145f87d04c46250c";

export default node;
